
import { dispatch } from '../store/'
import { LISTEN_CONNECTED_EVENTS, LISTEN_CONFIRMED_EVENTS } from '../constants/actionTypes';


export const dispatchConnectedEvents = (events) => {
    const payload = events
    return dispatch({type: LISTEN_CONNECTED_EVENTS, payload})
}

export const dispatchConfirmedEvents = (events) => {
    const payload = events
    return dispatch({type: LISTEN_CONFIRMED_EVENTS, payload})
}


// WEBPACK FOOTER //
// ./src/actions/adminEvents.js